//缺5、方缺
import makerjs from "makerjs";
// 矩形等去角 连线函数
function creatmySquareGap(area, param) {
      console.log("是否调用此函数creatOneCorner（）");
      console.log("是否调用此函数creatOneCorner（）param=", param);
      var xa = param.xa, ya = param.ya, xb = param.xb,
            yb = param.yb, xc = param.xc,
            xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf, glassH = param.glassH, glassW = param.glassW,
            yc = param.yc, xg = param.xg, yg = param.yg,
            xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
            x = param.x0, r = param.r, rd = param.rd, w = param.w, h = param.h,
            cutLine = param.cutLine, cutFilletRadius = param.cutFilletRadius;
      if (glassW * 1 > glassH * 1) {
            console.log("长边在X轴￥￥￥￥￥");
            if (area == "A") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xa, ya], [xa, ya - h]),
                              "BottomLine": new makerjs.paths.Line([xa, ya - h], [xa + w, ya - h]),
                              "RightLine": new makerjs.paths.Line([xa + w, ya - h], [xa + w, ya])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xa, ya+cutLine], [xa, ya]),
                              "LeftLine": new makerjs.paths.Line([xa, ya], [xa, ya - h]),
                              "BottomLine": new makerjs.paths.Line([xa, ya - h], [xa + w, ya - h]),
                              "RightLine": new makerjs.paths.Line([xa + w, ya - h], [xa + w, ya]),
                              "ExLine": new makerjs.paths.Line([xa + w, ya], [xa + w, ya+cutLine])
                        }
                  };
            } else if (area == "B") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xb-w/2, yb], [xb-w/2, yb - h]),
                              "BottomLine": new makerjs.paths.Line([xb-w/2, yb - h], [xb + w/2, yb - h]),
                              "RightLine": new makerjs.paths.Line([xb + w/2, yb - h], [xb + w/2, yb])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xb-w/2, yb+cutLine], [xb-w/2, yb]),
                              "LeftLine": new makerjs.paths.Line([xb-w/2, yb], [xb-w/2, yb - h]),
                              "BottomLine": new makerjs.paths.Line([xb-w/2, yb - h], [xb + w/2, yb - h]),
                              "RightLine": new makerjs.paths.Line([xb + w/2, yb - h], [xb + w/2, yb]),
                              "ExLine": new makerjs.paths.Line([xb + w/2, yb], [xb + w/2, yb+cutLine])
                        }
                  };

            } else if (area == "C") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xc - w, yc], [xc - w, yc - h]),
                              "BottomLine": new makerjs.paths.Line([xc - w, yc - h], [xc, yc - h]),
                              "RightLine": new makerjs.paths.Line([xc, yc - h], [xc, yc])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xc - w, yc+cutLine], [xc - w, yc]),
                              "LeftLine": new makerjs.paths.Line([xc - w, yc], [xc - w, yc - h]),
                              "BottomLine": new makerjs.paths.Line([xc - w, yc - h], [xc, yc - h]),
                              "RightLine": new makerjs.paths.Line([xc, yc - h], [xc, yc]),
                              "ExLine": new makerjs.paths.Line([xc, yc], [xc, yc+cutLine])
                        }
                  };
            } else if (area == "G") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xg, yg], [xg, yg + h]),
                              "BottomLine": new makerjs.paths.Line([xg, yg + h], [xg + w, yg + h]),
                              "RightLine": new makerjs.paths.Line([xg + w, yg + h], [xg + w, yg])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xg, yg-cutLine], [xg, yg]),
                              "LeftLine": new makerjs.paths.Line([xg, yg], [xg, yg + h]),
                              "BottomLine": new makerjs.paths.Line([xg, yg + h], [xg + w, yg + h]),
                              "RightLine": new makerjs.paths.Line([xg + w, yg + h], [xg + w, yg]),
                              "ExLine": new makerjs.paths.Line([xg + w, yg], [xg + w, yg-cutLine])
                        }
                  };
            } else if (area == "H") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xh-w/2, yh], [xh-w/2, yh + h]),
                              "BottomLine": new makerjs.paths.Line([xh-w/2, yh + h], [xh + w/2, yh + h]),
                              "RightLine": new makerjs.paths.Line([xh + w/2, yh + h], [xh + w/2, yh])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xh-w/2, yh-cutLine], [xh-w/2, yh]),
                              "LeftLine": new makerjs.paths.Line([xh-w/2, yh], [xh-w/2, yh + h]),
                              "BottomLine": new makerjs.paths.Line([xh-w/2, yh + h], [xh + w/2, yh + h]),
                              "RightLine": new makerjs.paths.Line([xh + w/2, yh + h], [xh + w/2, yh]),
                              "ExLine": new makerjs.paths.Line([xh + w/2, yh], [xh + w/2, yh-cutLine])
                        }
                  };
            } else if (area == "I") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xi - w, yi], [xi - w, yi + h]),
                              "BottomLine": new makerjs.paths.Line([xi - w, yi + h], [xi, yi + h]),
                              "RightLine": new makerjs.paths.Line([xi, yi + h], [xi, yi])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xi - w, yi-cutLine], [xi - w, yi]),
                              "LeftLine": new makerjs.paths.Line([xi - w, yi], [xi - w, yi + h]),
                              "BottomLine": new makerjs.paths.Line([xi - w, yi + h], [xi, yi + h]),
                              "RightLine": new makerjs.paths.Line([xi, yi + h], [xi, yi]),
                              "ExLine": new makerjs.paths.Line([xi, yi], [xi, yi-cutLine])
                        }
                  };
            }
            var fillet1 = makerjs.path.fillet(mySquareGap.paths.LeftLine, mySquareGap.paths.BottomLine, r);
            var fillet2 = makerjs.path.fillet(mySquareGap.paths.BottomLine, mySquareGap.paths.RightLine, r);
            mySquareGap.paths.fillet1 = fillet1;
            mySquareGap.paths.fillet2 = fillet2;
            var fillet11 = makerjs.path.fillet(mySquareGapWaterCut.paths.LeftLine, mySquareGapWaterCut.paths.BottomLine, r);
            var fillet22 = makerjs.path.fillet(mySquareGapWaterCut.paths.BottomLine, mySquareGapWaterCut.paths.RightLine, r);
            mySquareGapWaterCut.paths.fillet11 = fillet11;
            mySquareGapWaterCut.paths.fillet22 = fillet22;
      } else {
            console.log("短边在X轴￥￥￥￥￥");
            if (area == "A") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xa, ya], [xa + h, ya]),
                              "BottomLine": new makerjs.paths.Line([xa + h, ya], [xa + h, ya - w]),
                              "RightLine": new makerjs.paths.Line([xa + h, ya - w], [xa, ya - w])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xa-cutLine, ya], [xa, ya]),
                              "LeftLine": new makerjs.paths.Line([xa, ya], [xa + h, ya]),
                              "BottomLine": new makerjs.paths.Line([xa + h, ya], [xa + h, ya - w]),
                              "RightLine": new makerjs.paths.Line([xa + h, ya - w], [xa, ya - w]),
                              "ExLine": new makerjs.paths.Line([xa, ya - w], [xa-cutLine, ya - w])
                        }
                  };
            } else if (area == "D") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xd, yd + w / 2], [xd + h, yd + w / 2]),
                              "BottomLine": new makerjs.paths.Line([xd + h, yd + w / 2], [xd + h, yd - w / 2]),
                              "RightLine": new makerjs.paths.Line([xd + h, yd - w / 2], [xd, yd - w / 2])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xd-cutLine, yd + w / 2], [xd, yd + w / 2]),
                              "LeftLine": new makerjs.paths.Line([xd, yd + w / 2], [xd + h, yd + w / 2]),
                              "BottomLine": new makerjs.paths.Line([xd + h, yd + w / 2], [xd + h, yd - w / 2]),
                              "RightLine": new makerjs.paths.Line([xd + h, yd - w / 2], [xd, yd - w / 2]),
                              "ExLine": new makerjs.paths.Line([xd, yd - w / 2], [xd-cutLine, yd - w / 2])
                        }
                  };
            } else if (area == "C") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xc, yc], [xc - h, yc]),
                              "BottomLine": new makerjs.paths.Line([xc - h, yc], [xc - h, yc - w]),
                              "RightLine": new makerjs.paths.Line([xc - h, yc - w], [xc, yc - w])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xc+cutLine, yc], [xc, yc]),
                              "LeftLine": new makerjs.paths.Line([xc, yc], [xc - h, yc]),
                              "BottomLine": new makerjs.paths.Line([xc - h, yc], [xc - h, yc - w]),
                              "RightLine": new makerjs.paths.Line([xc - h, yc - w], [xc, yc - w]),
                              "ExLine": new makerjs.paths.Line([xc, yc - w], [xc+cutLine, yc - w])
                        }
                  };
            } else if (area == "G") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xg, yg], [xg + h, yg]),
                              "BottomLine": new makerjs.paths.Line([xg + h, yg], [xg + h, yg + w]),
                              "RightLine": new makerjs.paths.Line([xg + h, yg + w], [xg, yg + w])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xg-cutLine, yg], [xg, yg]),
                              "LeftLine": new makerjs.paths.Line([xg, yg], [xg + h, yg]),
                              "BottomLine": new makerjs.paths.Line([xg + h, yg], [xg + h, yg + w]),
                              "RightLine": new makerjs.paths.Line([xg + h, yg + w], [xg, yg + w]),
                              "ExLine": new makerjs.paths.Line([xg, yg + w], [xg-cutLine, yg + w])
                        }
                  };
            } else if (area == "F") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xf, yf + w / 2], [xf - h, yf + w / 2]),
                              "BottomLine": new makerjs.paths.Line([xf - h, yf + w / 2], [xf - h, yf - w / 2]),
                              "RightLine": new makerjs.paths.Line([xf - h, yf - w / 2], [xf, yf - w / 2])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xf+cutLine, yf + w / 2], [xf, yf + w / 2]),
                              "LeftLine": new makerjs.paths.Line([xf, yf + w / 2], [xf - h, yf + w / 2]),
                              "BottomLine": new makerjs.paths.Line([xf - h, yf + w / 2], [xf - h, yf - w / 2]),
                              "RightLine": new makerjs.paths.Line([xf - h, yf - w / 2], [xf, yf - w / 2]),
                              "ExLine": new makerjs.paths.Line([xf, yf - w / 2], [xf+cutLine, yf - w / 2])
                        }
                  };
            } else if (area == "I") {
                  var mySquareGap = {
                        paths: {
                              "LeftLine": new makerjs.paths.Line([xi, yi], [xi - h, yi]),
                              "BottomLine": new makerjs.paths.Line([xi - h, yi], [xi - h, yi + w]),
                              "RightLine": new makerjs.paths.Line([xi - h, yi + w], [xi, yi + w])
                        }
                  };
                  var mySquareGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xi+cutLine, yi], [xi, yi]),
                              "LeftLine": new makerjs.paths.Line([xi, yi], [xi - h, yi]),
                              "BottomLine": new makerjs.paths.Line([xi - h, yi], [xi - h, yi + w]),
                              "RightLine": new makerjs.paths.Line([xi - h, yi + w], [xi, yi + w]),
                              "ExLine": new makerjs.paths.Line([xi, yi + w], [xi+cutLine, yi + w])
                        }
                  };
            }

            var fillet1 = makerjs.path.fillet(mySquareGap.paths.LeftLine, mySquareGap.paths.BottomLine, r);
            var fillet2 = makerjs.path.fillet(mySquareGap.paths.BottomLine, mySquareGap.paths.RightLine, r);
            var fillet11 = makerjs.path.fillet(mySquareGapWaterCut.paths.LeftLine, mySquareGapWaterCut.paths.BottomLine, r);
            var fillet22 = makerjs.path.fillet(mySquareGapWaterCut.paths.BottomLine, mySquareGapWaterCut.paths.RightLine, r);
            mySquareGap.paths.fillet1 = fillet1;
            mySquareGap.paths.fillet2 = fillet2;
            mySquareGapWaterCut.paths.fillet11 = fillet11;
            mySquareGapWaterCut.paths.fillet22 = fillet22;
      }

      return [mySquareGap, mySquareGapWaterCut];
};
// 矩形等去角标记 连线函数      
function creatmySquareGapMark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
      console.log("是否调用此函数creatCornerMark()");
      console.log("是否调用此函数param", param);
      console.log("是否调用此函数outParam", outParam);
      console.log("是否调用此函数inputParam", inputParam);
      console.log("是否调用此函数OffsetParam", OffsetParam);
      var H = inputParam.H, R = inputParam.R, W = inputParam.W, X = inputParam.X, Y = inputParam.Y, myZoom = zoom * 1,
            xa = param.xa, ya = param.ya, xb = param.xb,
            yb = param.yb, xc = param.xc,
            xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf,
            yc = param.yc, xg = param.xg, yg = param.yg,
            xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
            x = param.x0, r = param.r, rd = param.rd, w = param.w, h = param.h,
            glassW = outParam.glassW, glassH = outParam.glassH,
            markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
            markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,
            w = W * 1 * myZoom,
            h = H * 1 * myZoom,
            r = R * 1 * myZoom,
            rd = r / Math.sqrt(2),
            hd = r - rd,
            x0 = X * 1 * myZoom,
            y0 = Y * 1 * myZoom;
      if (r !== 0) {
            var TxtR = "R=" + R;
      }
      if (h !== 0) {
            var TxtH = H;
      }
      if (w !== 0) {
            var TxtW = W;
      }
      if (x0 !== 0) {
            var TxtX = X;
      }
      if (y0 !== 0) {
            var TxtY = Y;
      }
      if (glassW * 1 > glassH * 1) {
            console.log("长边在X轴￥￥￥￥￥");
            if (area == "A") {
                  var myShgGapAMakerH = {
                        paths: {
                              "HALine0": new makerjs.paths.Line([xa + w + markShiftTwo, ya], [xa + w + markShiftTwo, ya - h]),
                              "HALine1": new makerjs.paths.Line([xa + w, ya - h], [xa + w + markShiftFour, ya - h]),
                        }
                  };
                  var myShgGapAMakerR = {
                        paths: {
                              "RALine0": new makerjs.paths.Line([xa + hd, ya - h + hd], [xa + r, ya - h + r]),
                        }
                  };
                  var myShgGapAMakerX = {
                        paths: {
                              "XALine0": new makerjs.paths.Line([xa - x0, ya + markShiftTwo], [xa, ya + markShiftTwo]),
                              "XALine1": new makerjs.paths.Line([xa - x0, ya], [xa - x0, ya + markShiftFour]),
                              "XALine2": new makerjs.paths.Line([xa, ya], [xa, ya + markShiftFour]),
                        }
                  };
                  var myShgGapAMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xa, ya], [xa, ya + markShiftFour]),
                              "WALine1": new makerjs.paths.Line([xa + w, ya], [xa + w, ya + markShiftFour]),
                              "WALine2": new makerjs.paths.Line([xa, ya + markShiftTwo], [xa + w, ya + markShiftTwo]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapAMakerH, TxtH, [xa + w + markShiftFour, ya - h], [xa + w + markShiftFour, ya]);//H文字标注
                  makerjs.model.addCaption(myShgGapAMakerX, TxtX, [xa - x0, ya + markShiftFour], [xa, ya + markShiftFour]);//X文字标注
                  makerjs.model.addCaption(myShgGapAMakerR, TxtR, [xa + r, ya - h + r + markShift], [xa + r + markShiftFour, ya - h + r + markShift]);//R文字标注  
                  makerjs.model.addCaption(myShgGapAMakerW, TxtW, [xa, ya + markShiftFour], [xa + w, ya + markShiftFour]);//W文字标注  
                  var markers = [myShgGapAMakerH, myShgGapAMakerX, myShgGapAMakerR, myShgGapAMakerW]
            } else if (area == "B") {
                  var myShgGapBMakerH = {
                        paths: {
                              "HBLine0": new makerjs.paths.Line([xb + w/2 + markShiftTwo, yb], [xb + w/2 + markShiftTwo, yb - h]),
                              "HBLine1": new makerjs.paths.Line([xb + w/2, yb - h], [xb + w/2 + markShiftFour, yb - h]),
                        }
                  };
                  var myShgGapBMakerR = {
                        paths: {
                              "RBLine0": new makerjs.paths.Line([xb-w/2 + hd, yb - h + hd], [xb-w/2 + r, yb - h + r]),
                        }
                  };
                  var myShgGapBMakerX = {
                        paths: {
                              // "XBLine0": new makerjs.paths.Line([xb - x0, yb + markShiftTwo], [xb, yb + markShiftTwo]),
                              // "XBLine1": new makerjs.paths.Line([xb - x0, yb], [xb - x0, yb + markShiftFour]),
                              // "XBLine2": new makerjs.paths.Line([xb, yb], [xb, yb + markShiftFour]),
                        }
                  };
                  var myShgGapBMakerW = {
                        paths: {
                              "WBLine0": new makerjs.paths.Line([xb-w/2, yb], [xb-w/2, yb + markShiftFour]),
                              "WBLine1": new makerjs.paths.Line([xb + w/2, yb], [xb + w/2, yb + markShiftFour]),
                              "WBLine2": new makerjs.paths.Line([xb-w/2, yb + markShiftTwo], [xb + w/2, yb + markShiftTwo]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapBMakerH, TxtH, [xb + w/2 + markShiftFour, yb - h], [xb + w/2 + markShiftFour, yb]);//H文字标注
                  makerjs.model.addCaption(myShgGapBMakerX, TxtX, [xb-w/2 - x0, yb + markShiftFour], [xb-w/2, yb + markShiftFour]);//X文字标注
                  makerjs.model.addCaption(myShgGapBMakerR, TxtR, [xb-w/2 + r, yb - h + r + markShift], [xb-w/2 + r + markShiftFour, yb - h + r + markShift]);//R文字标注  
                  makerjs.model.addCaption(myShgGapBMakerW, TxtW, [xb-w/2, yb + markShiftFour], [xb + w/2, yb + markShiftFour]);//W文字标注  
                  var markers = [myShgGapBMakerH, myShgGapBMakerX, myShgGapBMakerR, myShgGapBMakerW]
            } else if (area == "C") {
                  var myShgGapCMakerH = {
                        paths: {
                              "HCLine0": new makerjs.paths.Line([xc - w - markShiftTwo, yc], [xc - w - markShiftTwo, yc - h]),
                              "HCLine1": new makerjs.paths.Line([xc - w, yc - h], [xc - w - markShiftFour, yc - h]),
                        }
                  };
                  var myShgGapCMakerR = {
                        paths: {
                              "RCLine0": new makerjs.paths.Line([xc - hd, yc - h + hd], [xc - r, yc - h + r]),
                        }
                  };
                  var myShgGapCMakerX = {
                        paths: {
                              "XCLine0": new makerjs.paths.Line([xc + x0, yc + markShiftTwo], [xc, yc + markShiftTwo]),
                              "XCLine1": new makerjs.paths.Line([xc + x0, yc], [xc + x0, yc + markShiftFour]),
                              "XCLine2": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
                        }
                  };
                  var myShgGapCMakerW = {
                        paths: {
                              "WCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
                              "WCLine1": new makerjs.paths.Line([xc - w, yc], [xc - w, yc + markShiftFour]),
                              "WCLine2": new makerjs.paths.Line([xc, yc + markShiftTwo], [xc - w, yc + markShiftTwo]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapCMakerH, TxtH, [xc - w - markShiftFour, yc - h], [xc - w - markShiftFour, yc]);//H文字标注
                  makerjs.model.addCaption(myShgGapCMakerX, TxtX, [xc, yc + markShiftFour], [xc + x0, yc + markShiftFour]);//X文字标注
                  makerjs.model.addCaption(myShgGapCMakerR, TxtR, [xc - r - markShiftFour, yc - h + r + markShift], [xc - r, yc - h + r + markShift]);//R文字标注  
                  makerjs.model.addCaption(myShgGapCMakerW, TxtW, [xc - w, yc + markShiftFour], [xc, yc + markShiftFour]);//W文字标注  
                  var markers = [myShgGapCMakerH, myShgGapCMakerX, myShgGapCMakerR, myShgGapCMakerW]
            } else if (area == "G") {
                  var myShgGapGMakerH = {
                        paths: {
                              "HGLine0": new makerjs.paths.Line([xg + w + markShiftTwo, yg], [xg + w + markShiftTwo, yg + h]),
                              "HGLine1": new makerjs.paths.Line([xg + w, yg + h], [xg + w + markShiftFour, yg + h]),
                        }
                  };
                  var myShgGapGMakerR = {
                        paths: {
                              "RGLine0": new makerjs.paths.Line([xg + hd, yg + h - hd], [xg + r, yg + h - r]),
                        }
                  };
                  var myShgGapGMakerX = {
                        paths: {
                              "XGLine0": new makerjs.paths.Line([xg - x0, yg - markShiftTwo], [xg, yg - markShiftTwo]),
                              "XGLine1": new makerjs.paths.Line([xg - x0, yg], [xg - x0, yg - markShiftFour]),
                              "XGLine2": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
                        }
                  };
                  var myShgGapGMakerW = {
                        paths: {
                              "WGLine0": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
                              "WGLine1": new makerjs.paths.Line([xg + w, yg], [xg + w, yg - markShiftFour]),
                              "WGLine2": new makerjs.paths.Line([xg, yg - markShiftTwo], [xg + w, yg - markShiftTwo]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapGMakerH, TxtH, [xg + w + markShiftFour, yg], [xg + w + markShiftFour, yg + h]);//H文字标注
                  makerjs.model.addCaption(myShgGapGMakerX, TxtX, [xg - x0, yg - markShiftFour], [xg, yg - markShiftFour]);//X文字标注
                  makerjs.model.addCaption(myShgGapGMakerR, TxtR, [xg + r, yg + h - r - markShift], [xg + r + markShiftFour, yg + h - r - markShift]);//R文字标注  
                  makerjs.model.addCaption(myShgGapGMakerW, TxtW, [xg, yg - markShiftFour], [xg + w, yg - markShiftFour]);//W文字标注  
                  var markers = [myShgGapGMakerH, myShgGapGMakerX, myShgGapGMakerR, myShgGapGMakerW]
            } else if (area == "H") {
                  var myShgGapHMakerH = {
                        paths: {
                              "HHLine0": new makerjs.paths.Line([xh + w/2 + markShiftTwo, yh], [xh + w/2 + markShiftTwo, yh + h]),
                              "HHLine1": new makerjs.paths.Line([xh + w/2, yh + h], [xh + w/2 + markShiftFour, yh + h]),
                        }
                  };
                  var myShgGapHMakerR = {
                        paths: {
                              "RHLine0": new makerjs.paths.Line([xh-w/2 + hd, yh + h - hd], [xh-w/2 + r, yh + h - r]),
                        }
                  };
                  var myShgGapHMakerX = {
                        paths: {
                              "XHLine0": new makerjs.paths.Line([xh-w/2 - x0, yh - markShiftTwo], [xh-w/2, yh - markShiftTwo]),
                              "XHLine1": new makerjs.paths.Line([xh-w/2 - x0, yh], [xh-w/2 - x0, yh - markShiftFour]),
                              "XHLine2": new makerjs.paths.Line([xh-w/2, yh], [xh-w/2, yh - markShiftFour]),
                        }
                  };
                  var myShgGapHMakerW = {
                        paths: {
                              "WHLine0": new makerjs.paths.Line([xh-w/2, yh], [xh-w/2, yh - markShiftFour * 2]),
                              "WHLine1": new makerjs.paths.Line([xh + w/2, yh], [xh + w/2, yh - markShiftFour * 2]),
                              "WHLine2": new makerjs.paths.Line([xh-w/2, yh - markShiftFour - markShift], [xh + w/2, yh - markShiftFour - markShift]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapHMakerH, TxtH, [xh + w/2 + markShiftFour, yh], [xh + w/2 + markShiftFour, yh + h]);//H文字标注
                  makerjs.model.addCaption(myShgGapHMakerX, TxtX, [xh-w/2 - x0, yh - markShiftFour], [xh-w/2, yh - markShiftFour]);//X文字标注
                  makerjs.model.addCaption(myShgGapHMakerR, TxtR, [xh-w/2 + r, yh + h - r - markShift], [xh-w/2 + r + markShiftFour, yh + h - r - markShift]);//R文字标注  
                  makerjs.model.addCaption(myShgGapHMakerW, TxtW, [xh-w/2, yh - markShiftFour * 2], [xh + w/2, yh - markShiftFour * 2]);//W文字标注  
                  var markers = [myShgGapHMakerH, myShgGapHMakerX, myShgGapHMakerR, myShgGapHMakerW]
            } else if (area == "I") {
                  var myShgGapIMakerH = {
                        paths: {
                              "HILine0": new makerjs.paths.Line([xi - w - markShiftTwo, yi], [xi - w - markShiftTwo, yi + h]),
                              "HILine1": new makerjs.paths.Line([xi - w, yi + h], [xi - w - markShiftFour, yi + h]),
                        }
                  };
                  var myShgGapIMakerR = {
                        paths: {
                              "RILine0": new makerjs.paths.Line([xi - hd, yi + h - hd], [xi - r, yi + h - r]),
                        }
                  };
                  var myShgGapIMakerX = {
                        paths: {
                              "XILine0": new makerjs.paths.Line([xi + x0, yi - markShiftTwo], [xi, yi - markShiftTwo]),
                              "XILine1": new makerjs.paths.Line([xi + x0, yi], [xi + x0, yi - markShiftFour]),
                              "XILine2": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
                        }
                  };
                  var myShgGapIMakerW = {
                        paths: {
                              "WILine0": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
                              "WILine1": new makerjs.paths.Line([xi - w, yi], [xi - w, yi - markShiftFour]),
                              "WILine2": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi - w, yi - markShiftTwo]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapIMakerH, TxtH, [xi - w - markShiftFour, yi], [xi - w - markShiftFour, yi + h]);//H文字标注
                  makerjs.model.addCaption(myShgGapIMakerX, TxtX, [xi, yi - markShiftFour], [xi + x0, yi - markShiftFour]);//X文字标注
                  makerjs.model.addCaption(myShgGapIMakerR, TxtR, [xi - r - markShiftFour, yi + h - r - markShift], [xi - r, yi + h - r - markShift]);//R文字标注  
                  makerjs.model.addCaption(myShgGapIMakerW, TxtW, [xi - w, yi - markShiftFour], [xi, yi - markShiftFour]);//W文字标注  
                  var markers = [myShgGapIMakerH, myShgGapIMakerX, myShgGapIMakerR, myShgGapIMakerW]
            }
      } else {
            console.log("短边在X轴￥￥￥￥￥");
            if (area == "A") {
                  var myShgGapAMakerH = {
                        paths: {
                              "HALine0": new makerjs.paths.Line([xa, ya - w - markShiftTwo], [xa + h, ya - w - markShiftTwo]),
                              "HALine1": new makerjs.paths.Line([xa + h, ya - w - markShiftFour], [xa + h, ya - w]),
                        }
                  };
                  var myShgGapAMakerR = {
                        paths: {
                              "RALine0": new makerjs.paths.Line([xa + h - hd, ya - hd], [xa + h - r - markShiftTwo, ya - hd - r - markShiftTwo]),
                        }
                  };
                  var myShgGapAMakerY = {
                        paths: {
                              "YALine0": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya + y0]),
                              "YALine1": new makerjs.paths.Line([xa - markShiftFour, ya + y0], [xa, ya + y0]),
                              "YALine2": new makerjs.paths.Line([xa - markShiftFour, ya], [xa, ya]),
                        }
                  };
                  var myShgGapAMakerW = {
                        paths: {
                              //    "WALine0": new makerjs.paths.Line([xa, ya], [xa, ya + markShiftFour]),
                              //    "WALine1": new makerjs.paths.Line([xa+w, ya], [xa+w, ya + markShiftFour]),
                              "WALine2": new makerjs.paths.Line([xa + markShift, ya - w], [xa + markShift, ya]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapAMakerH, TxtH, [xa, ya - w - markShiftFour], [xa + h, ya - w - markShiftFour]);//H文字标注
                  makerjs.model.addCaption(myShgGapAMakerY, TxtY, [xa - markShiftFour, ya], [xa - markShiftFour, ya + y0]);//X文字标注
                  makerjs.model.addCaption(myShgGapAMakerR, TxtR, [xa + h - r - markShiftFour, ya - hd - r - markShiftFour], [xa + h - r - markShiftTwo, ya - hd - r - markShiftFour]);//R文字标注  
                  makerjs.model.addCaption(myShgGapAMakerW, TxtW, [xa + markShiftThree, ya - w], [xa + markShiftThree, ya]);//W文字标注  
                  var markers = [myShgGapAMakerH, myShgGapAMakerY, myShgGapAMakerR, myShgGapAMakerW]
            } else if (area == "D") {
                  var myShgGapDMakerH = {
                        paths: {
                              "HDLine0": new makerjs.paths.Line([xd, yd - w / 2 - markShiftTwo], [xd + h, yd - w / 2 - markShiftTwo]),
                              "HDLine1": new makerjs.paths.Line([xd + h, yd - w / 2 - markShiftFour], [xd + h, yd - w / 2]),
                        }
                  };
                  var myShgGapDMakerR = {
                        paths: {
                              "RDLine0": new makerjs.paths.Line([xd + h - hd, yd - hd + w / 2], [xd + h - r - markShiftTwo, yd - hd - r - markShiftTwo + w / 2]),
                        }
                  };
                  var myShgGapDMakerY = {
                        paths: {
                              "YDLine0": new makerjs.paths.Line([xd - markShiftTwo, yd + w / 2], [xd - markShiftTwo, yd + y0 + w / 2]),
                              "YDLine1": new makerjs.paths.Line([xd - markShiftFour, yd + y0 + w / 2], [xd, yd + y0 + w / 2]),
                              "YDLine2": new makerjs.paths.Line([xd - markShiftFour, yd + w / 2], [xd, yd + w / 2]),
                        }
                  };
                  var myShgGapDMakerW = {
                        paths: {
                              //    "WDLine0": new makerjs.paths.Line([xd, yd], [xd, yd + markShiftFour]),
                              //    "WDLine1": new makerjs.paths.Line([xd+w, yd], [xd+w, yd + markShiftFour]),
                              "WDLine2": new makerjs.paths.Line([xd + markShift, yd - w / 2], [xd + markShift, yd + w / 2]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapDMakerH, TxtH, [xd, yd - w / 2 - markShiftFour], [xd + h, yd - w / 2 - markShiftFour]);//H文字标注
                  makerjs.model.addCaption(myShgGapDMakerY, TxtY, [xd - markShiftFour, yd + w / 2], [xd - markShiftFour, yd + y0 + w / 2]);//X文字标注
                  makerjs.model.addCaption(myShgGapDMakerR, TxtR, [xd + h - r - markShiftFour, yd - hd - r - markShiftFour + w / 2], [xd + h - r - markShiftTwo, yd - hd - r - markShiftFour + w / 2]);//R文字标注  
                  makerjs.model.addCaption(myShgGapDMakerW, TxtW, [xd + markShiftThree, yd - w / 2], [xd + markShiftThree, yd + w / 2]);//W文字标注  
                  var markers = [myShgGapDMakerH, myShgGapDMakerY, myShgGapDMakerR, myShgGapDMakerW]
            } else if (area == "C") {
                  var myShgGapCMakerH = {
                        paths: {
                              "HCLine0": new makerjs.paths.Line([xc, yc - w - markShiftTwo], [xc - h, yc - w - markShiftTwo]),
                              "HCLine1": new makerjs.paths.Line([xc - h, yc - w - markShiftFour], [xc - h, yc - w]),
                        }
                  };
                  var myShgGapCMakerR = {
                        paths: {
                              "RCLine0": new makerjs.paths.Line([xc - h + hd, yc - hd], [xc - h + r + markShiftTwo, yc - hd - r - markShiftTwo]),
                        }
                  };
                  var myShgGapCMakerY = {
                        paths: {
                              "YCLine0": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc + y0]),
                              "YCLine1": new makerjs.paths.Line([xc + markShiftFour, yc + y0], [xc, yc + y0]),
                              "YCLine2": new makerjs.paths.Line([xc + markShiftFour, yc], [xc, yc]),
                        }
                  };
                  var myShgGapCMakerW = {
                        paths: {
                              //    "WCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
                              //    "WCLine1": new makerjs.paths.Line([xc+w, yc], [xc+w, yc + markShiftFour]),
                              "WCLine2": new makerjs.paths.Line([xc - markShift, yc - w], [xc - markShift, yc]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapCMakerH, TxtH, [xc - h, yc - w - markShiftFour], [xc, yc - w - markShiftFour]);//H文字标注
                  makerjs.model.addCaption(myShgGapCMakerY, TxtY, [xc + markShiftFour, yc], [xc + markShiftFour, yc + y0]);//X文字标注
                  makerjs.model.addCaption(myShgGapCMakerR, TxtR, [xc - h + r + markShiftTwo, yc - hd - r - markShiftFour], [xc - h + r + markShiftFour, yc - hd - r - markShiftFour]);//R文字标注  
                  makerjs.model.addCaption(myShgGapCMakerW, TxtW, [xc - markShiftThree, yc - w], [xc - markShiftThree, yc]);//W文字标注  
                  var markers = [myShgGapCMakerH, myShgGapCMakerY, myShgGapCMakerR, myShgGapCMakerW]
            } else if (area == "G") {
                  var myShgGapGMakerH = {
                        paths: {
                              "HGLine0": new makerjs.paths.Line([xg, yg + w + markShiftTwo], [xg + h, yg + w + markShiftTwo]),
                              "HGLine1": new makerjs.paths.Line([xg + h, yg + w + markShiftFour], [xg + h, yg + w]),
                        }
                  };
                  var myShgGapGMakerR = {
                        paths: {
                              "RGLine0": new makerjs.paths.Line([xg + h - hd, yg + hd], [xg + h - r - markShiftTwo, yg + hd + r + markShiftTwo]),
                        }
                  };
                  var myShgGapGMakerY = {
                        paths: {
                              "YGLine0": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg - y0]),
                              "YGLine1": new makerjs.paths.Line([xg - markShiftFour, yg - y0], [xg, yg - y0]),
                              "YGLine2": new makerjs.paths.Line([xg - markShiftFour, yg], [xg, yg]),
                        }
                  };
                  var myShgGapGMakerW = {
                        paths: {
                              //    "WGLine0": new makerjs.paths.Line([xg, yg], [xg, yg + markShiftFour]),
                              //    "WGLine1": new makerjs.paths.Line([xg+w, yg], [xg+w, yg + markShiftFour]),
                              "WGLine2": new makerjs.paths.Line([xg + markShift, yg + w], [xg + markShift, yg]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapGMakerH, TxtH, [xg, yg + w + markShiftFour], [xg + h, yg + w + markShiftFour]);//H文字标注
                  makerjs.model.addCaption(myShgGapGMakerY, TxtY, [xg - markShiftFour, yg - y0], [xg - markShiftFour, yg]);//X文字标注
                  makerjs.model.addCaption(myShgGapGMakerR, TxtR, [xg + h - r - markShiftFour, yg + hd + r + markShiftFour], [xg + h - r - markShiftTwo, yg + hd + r + markShiftFour]);//R文字标注  
                  makerjs.model.addCaption(myShgGapGMakerW, TxtW, [xg + markShiftThree, yg], [xg + markShiftThree, yg + w]);//W文字标注  
                  var markers = [myShgGapGMakerH, myShgGapGMakerY, myShgGapGMakerR, myShgGapGMakerW]
            } else if (area == "F") {
                  var myShgGapFMakerH = {
                        paths: {
                              "HFLine0": new makerjs.paths.Line([xf, yf - w / 2 - markShiftTwo], [xf - h, yf - w / 2 - markShiftTwo]),
                              "HFLine1": new makerjs.paths.Line([xf - h, yf - w / 2 - markShiftFour], [xf - h, yf - w / 2]),
                        }
                  };
                  var myShgGapFMakerR = {
                        paths: {
                              "RFLine0": new makerjs.paths.Line([xf - h + hd, yf - hd + w / 2], [xf - h + r + markShiftTwo, yf - hd - r - markShiftTwo + w / 2]),
                        }
                  };
                  var myShgGapFMakerY = {
                        paths: {
                              "YFLine0": new makerjs.paths.Line([xf + markShiftTwo, yf + w / 2], [xf + markShiftTwo, yf + y0 + w / 2]),
                              "YFLine1": new makerjs.paths.Line([xf + markShiftFour, yf + y0 + w / 2], [xf, yf + y0 + w / 2]),
                              "YFLine2": new makerjs.paths.Line([xf + markShiftFour, yf + w / 2], [xf, yf + w / 2]),
                        }
                  };
                  var myShgGapFMakerW = {
                        paths: {
                              //    "WFLine0": new makerjs.paths.Line([xf, yf], [xf, yf + markShiftFour]),
                              //    "WFLine1": new makerjs.paths.Line([xf+w, yf], [xf+w, yf + markShiftFour]),
                              "WFLine2": new makerjs.paths.Line([xf - markShift, yf - w / 2], [xf - markShift, yf + w / 2]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapFMakerH, TxtH, [xf - h, yf - w / 2 - markShiftFour], [xf, yf - w / 2 - markShiftFour]);//H文字标注
                  makerjs.model.addCaption(myShgGapFMakerY, TxtY, [xf + markShiftFour, yf + w / 2], [xf + markShiftFour, yf + y0 + w / 2]);//X文字标注
                  makerjs.model.addCaption(myShgGapFMakerR, TxtR, [xf - h + r + markShiftTwo, yf - hd - r - markShiftFour + w / 2], [xf - h + r + markShiftFour, yf - hd - r - markShiftFour + w / 2]);//R文字标注  
                  makerjs.model.addCaption(myShgGapFMakerW, TxtW, [xf - markShiftThree, yf - w / 2], [xf - markShiftThree, yf + w / 2]);//W文字标注  
                  var markers = [myShgGapFMakerH, myShgGapFMakerY, myShgGapFMakerR, myShgGapFMakerW]
            } else if (area == "I") {
                  var myShgGapIMakerH = {
                        paths: {
                              "HILine0": new makerjs.paths.Line([xi, yi + w + markShiftTwo], [xi - h, yi + w + markShiftTwo]),
                              "HILine1": new makerjs.paths.Line([xi - h, yi + w + markShiftFour], [xi - h, yi + w]),
                        }
                  };
                  var myShgGapIMakerR = {
                        paths: {
                              "RILine0": new makerjs.paths.Line([xi - h + hd, yi + hd], [xi - h + r + markShiftTwo, yi + hd + r + markShiftTwo]),
                        }
                  };
                  var myShgGapIMakerY = {
                        paths: {
                              "YILine0": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi - y0]),
                              "YILine1": new makerjs.paths.Line([xi + markShiftFour, yi - y0], [xi, yi - y0]),
                              "YILine2": new makerjs.paths.Line([xi + markShiftFour, yi], [xi, yi]),
                        }
                  };
                  var myShgGapIMakerW = {
                        paths: {
                              //    "WILine0": new makerjs.paths.Line([xi, yi], [xi, yi + markShiftFour]),
                              //    "WILine1": new makerjs.paths.Line([xi+w, yi], [xi+w, yi + markShiftFour]),
                              "WILine2": new makerjs.paths.Line([xi - markShift, yi + w], [xi - markShift, yi]),
                        }
                  };
                  makerjs.model.addCaption(myShgGapIMakerH, TxtH, [xi - h, yi + w + markShiftFour], [xi, yi + w + markShiftFour]);//H文字标注
                  makerjs.model.addCaption(myShgGapIMakerY, TxtY, [xi + markShiftFour, yi - y0], [xi + markShiftFour, yi]);//X文字标注
                  makerjs.model.addCaption(myShgGapIMakerR, TxtR, [xi - h + r + markShiftTwo, yi + hd + r + markShiftFour], [xi - h + r + markShiftFour, yi + hd + r + markShiftFour]);//R文字标注  
                  makerjs.model.addCaption(myShgGapIMakerW, TxtW, [xi - markShiftThree, yi], [xi - markShiftThree, yi + w]);//W文字标注  
                  var markers = [myShgGapIMakerH, myShgGapIMakerY, myShgGapIMakerR, myShgGapIMakerW]
            }
      }

      console.log("markers||||||||||||||||||=", markers)
      return markers;
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function SquareGap(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut, cutLine, cutFilletRadius) {


      var frame = outParam.shapeName;
      console.log("outParam==", outParam)
      console.log("model==", model)
      console.log("inputParam==", inputParam)
      console.log("outParam.shapeName==////////", outParam.shapeName)
      if (typeof (frame) == "undefined") {
            var H = inputParam.H, R = inputParam.R, W = inputParam.W, X = inputParam.X, Y = inputParam.Y, area = inputParam.area, myZoom = zoom * 1, myθCut = θCut, myrCut = rCut,
                  plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
                  glassW = outParam.glassW, glassH = outParam.glassH, cutLine = cutLine * 1, cutFilletRadius = cutFilletRadius * 1,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
                  w = W * 1 * myZoom,
                  h = H * 1 * myZoom,
                  r = R * 1 * myZoom,
                  rd = r / Math.sqrt(2),
                  x0 = X * 1 * myZoom,
                  y0 = Y * 1 * myZoom;
            if (plate.models === undefined || plate.models === "") {
                  console.log("1111111111111111");
                  plate.models = {};
            }
            if (cutPlate.models === undefined || cutPlate.models === "") {
                  console.log("22222222222");
                  //cutPlate.models={};
                  cutPlate.models = {};
            }
            if (markers.models === undefined || markers.models === "") {
                  console.log("333333333333");
                  markers.models = {};
            }
            if (r !== 0) {
                  var TxtR = "R=" + R;
            }
            if (h !== 0) {
                  var TxtH = H;
            }
            if (w !== 0) {
                  var TxtW = W;
            }
            if (x0 !== 0) {
                  var TxtX = X;
            }
            if (y0 !== 0) {
                  var TxtY = Y;
            }
      } else {
            var H = inputParam.H, R = inputParam.R, W = inputParam.W, X = inputParam.X, Y = inputParam.Y, area = inputParam.area, myZoom = zoom * 1, myθCut = θCut, myrCut = rCut,
                  plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
                  glassW = outParam.glassW, glassH = outParam.glassH, cutLine = cutLine * 1, cutFilletRadius = cutFilletRadius * 1,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
                  w = W * 1 * myZoom,
                  h = H * 1 * myZoom,
                  r = R * 1 * myZoom,
                  rd = r / Math.sqrt(2),
                  x0 = X * 1 * myZoom,
                  y0 = Y * 1 * myZoom;
            if (plate.models === undefined || plate.models === "") {
                  console.log("1111111111111111");
                  plate.models = {};
            }
            if (cutPlate.models === undefined || cutPlate.models === "") {
                  console.log("22222222222");
                  //cutPlate.models={};
                  cutPlate.models = {};
            }
            if (markers.models === undefined || markers.models === "") {
                  console.log("333333333333");
                  markers.models = {};
            }
            if (r !== 0) {
                  var TxtR = "R=" + R;
            }
            if (h !== 0) {
                  var TxtH = H;
            }
            if (w !== 0) {
                  var TxtW = W;
            }
            if (x0 !== 0) {
                  var TxtX = X;
            }
            if (y0 !== 0) {
                  var TxtY = Y;
            }
      }
      if (frame == "Rectangle") {
            console.log("frame==undefined||||*****")
            //在A区域 计算孔的位置       
            var xa = x0, ya = glassH * 1 - y0,
                  //B区域//只有Y标注没有X标注 
                  xb = glassW * 1 / 2, yb = glassH * 1 - y0,
                  //C区域
                  xc = glassW * 1 - x0, yc = glassH * 1 - y0,
                  //D区域
                  //只有X标注没有Y标注 
                  xd = x0, yd = glassH * 1 / 2,
                  //E区域
                  //只有X标注没有Y标注 
                  xe = glassW * 1 / 2, ye = glassH * 1 / 2,
                  //F区域
                  //只有X标注没有Y标注 
                  xf = glassW * 1 - x0, yf = glassH * 1 / 2,
                  //在G区域 计算孔的位置
                  xg = x0, yg = y0,
                  //在H区域 计算孔的位置
                  //只标注Y
                  xh = glassW * 1 / 2, yh = y0,
                  //在I区域 计算孔的位置
                  xi = glassW * 1 - x0, yi = y0;
            var OffsetParam = {};
      } else if (frame == "IsoscelesTrapezoid") {

      } else if (frame == "RightAngledTrapezoid") {
            d

      } else if (frame == "OtherTrapezoidsA") {

      } else if (frame == "OtherTrapezoidsB") {

      } else if (frame == "ParallelogramA") {


      } else if (frame == "ParallelogramB") {

      }
      // 坐标参数
      var paramCoordinate = { x0, rd, w, h, r, cutLine, cutFilletRadius, xa, ya, xb, yb, xc, yc, xd, yd, xf, yf, xg, yg, xh, yh, xi, yi, glassW, glassH };
      const allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
      var areaPoint = "";
      console.log("//角7、地弹簧3 ------", allKeys)
      if (allKeys[0] == frame) {
            allKeys.shift();//去掉数组第一个元素
      }
      console.log("//角7、地弹簧3 位置去掉数组第一个元素------", allKeys)
      switch (area) {
            case "1": areaPoint = "A"; break;
            case "2": areaPoint = "B"; break;
            case "3": areaPoint = "C"; break;
            case "4": areaPoint = "D"; break;
            case "6": areaPoint = "F"; break;
            case "7": areaPoint = "G"; break;
            case "8": areaPoint = "H"; break;
            case "9": areaPoint = "I"; break;
      }
      /**
      * 画图
      * 
      */
      var ObjName = "mySquareGap" + areaPoint;
      var ObjNameMmySquareGap = "mySquareGap" + areaPoint + "Mark";//角标记
      ObjName = creatmySquareGap(areaPoint, paramCoordinate);//图形
      console.log("ObjName===|||||||||", ObjName);
      ObjNameMmySquareGap = creatmySquareGapMark(outParam, areaPoint, paramCoordinate, inputParam, fixedParam, OffsetParam, zoom);//图形
      console.log("ObjNameMmySquareGap===|||||||||角标注", ObjNameMmySquareGap);
      console.log("cutPlate.models====************", cutPlate.models),
            console.log("plate.models====**************", plate.models),
            console.log("markers.models====*************", markers.models),
            // myShgGapAMakerH,myShgGapAMakerX,myShgGapAMakerD,myShgGapAMakerW
            cutPlate.models["TypeGap_mySquareGap" + areaPoint + myHolesNum] = ObjName[1];
      plate.models["TypeGap_mySquareGap" + areaPoint + myHolesNum] = ObjName[1];
      markers.models["TypeGap_mySquareGap" + areaPoint + myHolesNum] = ObjName[1];
      markers.models["TypeGap_mySquareGapH" + areaPoint + myHolesNum + "Mark"] = ObjNameMmySquareGap[0];
      markers.models["TypeGap_mySquareGapX" + areaPoint + myHolesNum + "Mark"] = ObjNameMmySquareGap[1];
      markers.models["TypeGap_mySquareGapR" + areaPoint + myHolesNum + "Mark"] = ObjNameMmySquareGap[2];
      markers.models["TypeGap_mySquareGapW" + areaPoint + myHolesNum + "Mark"] = ObjNameMmySquareGap[3];

      myHolesNum++;
      return { plate, cutPlate, markers, myHolesNum }
};


export default SquareGap;